import styled from "@emotion/styled";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import { EyeOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";
import { Button, Form, Input, Modal } from "antd";
import { useLocation, useNavigate } from "react-router-dom";

import styles from "./authen.module.css";
import { ResponseDataType, postRequest } from "api";

const AccountPageWrapper = styled.div`
  width: 100%;
  min-height: 100vh; 
  display: flex;
  flex-direction: column;
  justify-content: center; 
  align-items: center;
  padding: 20px;
`;

const FormWrapper = styled.div``;

export const ForgotPassword = () => {
  const location = useLocation();
  const email = location.state?.email || "";
  const [form] = Form.useForm();
  const navigate = useNavigate();


  const ChangePassword = async (value: {
    email: string;
    newPassword: string;
    confirmPassword: string;
  }) => {
    try {
      const response: ResponseDataType<{}> = await postRequest(
        "/auth/forgot-password",
        {
          email: value.email,
          newPassword: value.newPassword,
          confirmPassword: value.confirmPassword,
        }
      );

      if (response.code) {
        if (typeof response.message === "object") {
          response.message.forEach((message: string) => toast.error(message));
        } else toast.error(response.message);
      } else {
        Modal.confirm({
          style: { fontFamily: "Quicksand" },
          title: "Xác nhận",
          content: "Bạn có chắc muốn đổi sang mật khẩu mới này?",
          okText: "Đồng ý",
          cancelText: "Hủy",
          onOk: () => {
            navigate("/confirmNewPass", { state: { email: value.email } });
            form.resetFields();
          },
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <AccountPageWrapper>
      <FormWrapper>
        <Form form={form} onFinish={value => ChangePassword(value)}>
          <div
            className={`${styles.form} ${styles.change_password_form} authen-form`}
          >
            <Form.Item
              name="email"
              initialValue={email} // lấy email từ state nếu có
              rules={[
                { required: true, message: "Cần nhập email!" },
                { type: "email", message: "Cần nhập email đúng định dạng!" },
              ]}
              style={{ margin: 0, width: "100%" }}
            >
              <Input
                prefix={<EmailOutlinedIcon sx={{ fontSize: "29.5px" }} />}
                placeholder="Nhập email"
                className={styles.customInputWrapper}
              />
            </Form.Item>
            <div className={styles.line} />
            <Form.Item
              name="newPassword"
              rules={[
                { required: true, message: "Cần nhập mật khẩu mới!" },
                { min: 6, message: "Mật khẩu gồm tối thiêu 6 kí tự" },
                {
                  pattern: new RegExp(/^[a-zA-Z0-9]*$/),
                  message: "Mật khẩu không chứa kí tự đặc biệt và dấu cách",
                },
              ]}
              style={{ margin: 0 }}
            >
              <Input.Password
                prefix={<EyeOutlined className={styles.icon} />}
                placeholder="Mật khẩu"
                className={styles.customInputWrapper}
              />
            </Form.Item>
            <div className={styles.line} />
            <Form.Item
              name="confirmPassword"
              rules={[
                { required: true, message: "Cần xác nhận lại mật khẩu mới!" },
                { min: 6, message: "Mật khẩu gồm tối thiêu 6 kí tự" },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("newPassword") === value) {
                      return Promise.resolve();
                    } else
                      return Promise.reject("Mật khẩu xác nhận không khớp");
                  },
                }),
              ]}
              style={{ margin: 0 }}
            >
              <Input.Password
                prefix={<EyeOutlined className={styles.icon} />}
                placeholder="Xác nhận mật khẩu mới"
                className={styles.customInputWrapper}
              />
            </Form.Item>
          </div>
          <Button
            type="primary"
            className={styles.authen_button}
            htmlType="submit"
          >
            Đổi mật khẩu
          </Button>
        </Form>
      </FormWrapper>
    </AccountPageWrapper>
  );
};